

//
// This defines window.ws.call_post('url',{a:'datas',b:1});
//

(function(){

    //
    // A function that does a post request (not ajax)
    //
    function call_post(url, data){

        // Check token
        if(!window.ws.csrf_token){
            console.error("No CSRF Token set for this portal");
            return;
        }


        let postdata = { "_token": window.ws.csrf_token };
        if (data) {
            for (var attrname in data) { postdata[attrname] = data[attrname]; }
        }
        let f = ws_form(url, postdata, "POST");
        f.submit();
    }

    // The post form requests
    function ws_form(url, data = {}, method = 'POST') {

        const form = $('<form>').attr({
            method: method,
            action: url
        }).css({
            display: 'none'
        });

        const addData = function(name, data) {
            if ($.isArray(data)) {
                for (let i = 0; i < data.length; i++) {
                    let value = data[i];
                    addData(name + '[]', value);
                }
            } else if (typeof data === 'object') {
                for (let key in data) {
                    if (data.hasOwnProperty(key)) {
                        addData(name + '[' + key + ']', data[key]);
                    }
                }
            } else if (data != null) {
                form.append($('<input>').attr({
                    type: 'hidden',
                    name: String(name),
                    value: String(data)
                }));
            }
        };

        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                addData(key, data[key]);
            }
        }

        return form.appendTo('body');
    }



    //
    // Set stuff in our object
    //
    window.ws.call_post = call_post;


})(); // End auto-executable anonymous function







